import { motion, AnimatePresence } from 'framer-motion';
import { useLang } from '../../i18n/LanguageContext';

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel, confirmText, confirmVariant = 'danger' }) {
  const { t } = useLang();
  if (!isOpen) return null;

  const confirmStyles = {
    danger: { background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: '#fff' },
    success: { background: 'linear-gradient(135deg, #228B22, #166416)', color: '#fff' },
    warning: { background: 'linear-gradient(135deg, #c9a227, #a0821f)', color: '#fff' },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="confirm-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onCancel}
        >
          <motion.div
            className="confirm-modal-box"
            initial={{ opacity: 0, scale: 0.85, y: -20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.85, y: -20 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
            onClick={e => e.stopPropagation()}
          >
            <div className="confirm-modal-icon">
              {confirmVariant === 'danger' ? (
                <i className="bi bi-exclamation-triangle-fill" style={{ color: '#dc2626', fontSize: '2.5rem' }}></i>
              ) : confirmVariant === 'success' ? (
                <i className="bi bi-check-circle-fill" style={{ color: '#228B22', fontSize: '2.5rem' }}></i>
              ) : (
                <i className="bi bi-question-circle-fill" style={{ color: '#c9a227', fontSize: '2.5rem' }}></i>
              )}
            </div>
            <h5 className="confirm-modal-title">{title}</h5>
            <p className="confirm-modal-message">{message}</p>
            <div className="confirm-modal-actions">
              <button className="confirm-modal-cancel" onClick={onCancel}>
                <i className="bi bi-x-circle me-2"></i>{t('common.cancel')}
              </button>
              <button
                className="confirm-modal-confirm"
                style={confirmStyles[confirmVariant] || confirmStyles.danger}
                onClick={onConfirm}
              >
                <i className={`bi ${confirmVariant === 'danger' ? 'bi-trash' : 'bi-check-lg'} me-2`}></i>
                {confirmText || t('common.confirm')}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
